import type { CursorPaginatedRecordArray } from 'garaje/types/pagination';

/**
 * Extracts cursor value from a pagination link URL
 * @param link - URL string like "https://some.url?cursor=abc"
 * @returns The cursor value or null if not found
 */
export function getCursorFromLink(link: string | null | undefined, key: string = 'cursor'): string | null {
  if (!link) {
    return null;
  }

  try {
    const url = new URL(link);
    // eslint-disable-next-line ember/use-ember-get-and-set
    return url.searchParams.get(`page[${key}]`);
  } catch {
    return null;
  }
}

/**
 * Formats pagination links in API payload to extract cursors into meta
 * @param payload - API response payload with links
 * @returns The modified payload with cursor meta
 */
export function formatPaginationLinks(
  payload: CursorPaginatedRecordArray<unknown>,
): CursorPaginatedRecordArray<unknown> {
  if (payload.links && (payload.links.first || payload.links.prev || payload.links.next)) {
    const meta = { ...payload.meta };
    const firstCursor = getCursorFromLink(payload.links.first);
    if (firstCursor) {
      meta.firstCursor = firstCursor;
    }
    const previousCursor = getCursorFromLink(payload.links.prev);
    if (previousCursor) {
      meta.previousCursor = previousCursor;
    }
    const nextCursor = getCursorFromLink(payload.links.next);
    if (nextCursor) {
      meta.nextCursor = nextCursor;
    }
    payload.meta = meta;
  }
  return payload;
}
